<template>
<!-- FOOTER -->
<footer class="footer" :class="{ active: $store.state.footer.active, close: !$store.state.footer.active}">
  <div @click="setLocale('fr')" class="french flag" v-if="this.$root.$i18n.locale!=='fr'" />
  <div @click="setLocale('en')" class="english flag" v-if="this.$root.$i18n.locale!=='en'" />
  <button class="footer_btn" @click="toggleFooter">© Cartoradio - ANFR</button>
  <div class="mentions">
    <a href="https://www.ign.fr/" target="_blank">© IGN </a>
     -
    <a href="https://www.openstreetmap.org/copyright" target="_blank"> © {{$t("message['OpenStreetMap']")}}</a>
   </div>
  <div class="footer_content">
    <aside class="footer_lien">
      <div class="lien_inside" style="margin: 0 auto; display: table;">
        <p class="title">{{ $t("message['Un site web de l ANFR']") }}</p>
        <div class="footer_logos">
          <a href="http://www.anfr.fr" target="_blank">
            <img src="../assets/img/logo-marianne-anfr.svg" alt="République Française">
          </a>
        </div>
      </div>
    </aside>
    <aside class="footer_lien socials">
      <div class="lien_inside" style="margin: 0 auto; display: table;">
        <p class="title">{{ $t("message['Suivre l Agence Nationale des Fréquences']") }}</p>
        <ul class="pan">
          <li class="icon_chevron_right"><a class="link" target="_blank" href="http://www.anfr.fr">www.anfr.fr</a></li>
        </ul>
        <div class="footer_lien_icons">
          <a class="footer_lien_icon footer_lien_icon_facebook" href="https://www.facebook.com/agencenationaledesfrequences/" title="Facebook" target="_blank"></a>
          <a class="footer_lien_icon footer_lien_icon_twitter" href="https://x.com/anfr" title="X" target="_blank"></a>
          <a class="footer_lien_icon footer_lien_icon_youtube" href="https://www.youtube.com/c/Agencenationaledesfrequences" title="Youtube" target="_blank"></a>
          <a class="footer_lien_icon footer_lien_icon_flickr" href="https://www.flickr.com/anfr/" title="Flickr" target="_blank"></a>
          <a class="footer_lien_icon footer_lien_icon_linkedin" href="https://www.linkedin.com/company/anfr/" title="LinkedIn" target="_blank"></a>
        </div>
      </div>
    </aside>
    <aside class="footer_lien">
      <div class="lien_inside">
        <ul class="pan">
          <li class="icon_chevron_right">
            <router-link class="link" to="/mentions-legales">{{ $t("message['Mentions légales']") }}</router-link>
          </li>
          <li class="icon_chevron_right">
            <router-link class="link" to="/cgu">{{ $t("message['CGU']") }}</router-link>
          </li>
          <li class="icon_chevron_right"><a class="link" :href="this.urlFAQ" target="_blank">{{ $t("message['FAQ']") }}</a></li>
        </ul>
      </div>
    </aside>
  </div>
  <span class="app-version" :title="appVersion  + ' - ' + appCommitHash">{{ appVersion }}</span>
</footer>
</template>

<script>
import '../assets/css/footer.css'

// https://github.com/marcuswestin/store.js/
import storeJs from 'store'

export default {
  name: 'CrFooter',

  data() {
    return {
      appVersion: process.env.APP_VERSION,
      appCommitHash: process.env.APP_COMMITHASH.substr(0, 5)
    }
  },
  computed: {
    urlFAQ() {
      return this.$store.state.paramUrl.URL_FAQ ? this.$store.state.paramUrl.URL_FAQ : ''
    }
  },
  methods: {
    toggleFooter: function() {
      this.$store.dispatch('footerToggle')
    },
    setLocale: function(newLocale) {
      this.$root.$i18n.locale = newLocale
      storeJs.set('cr:locale', newLocale)
    }
  }
}
</script>

<style scoped>
/* Drapeau visible dans le footer uniquement quand la carte est active */

@media screen and (min-width: 1025px) {
  body .flag {
    display: none;
  }
  body.map .flag {
    display: block;
  }
}
@media screen and (max-width: 950px) {
  .mentions {
    position: static !important;
    text-align: center;
    margin-top: 1em;
  }

}

.flag {
  position: absolute;
  top: 10px;
  left: 10px;
}

.app-version {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 0.8em;
  color: #dfdfdf29;
}
.mentions{
  position: absolute;
  top: 5px;
  right: 50px;
  color: #fff;
}

.mentions a {
  color: #fff;
}

</style>
